import { capitalize, cn } from "@repo/shared/utils";
import type { PhoneNumber } from "@repo/types";
import { Input } from "@repo/ui/components/Base/Input";
import { SelectItem } from "@repo/ui/components/Base/Select";
import { SelectInput } from "@repo/ui/components/Base/SelectInput";

export const PhoneFormField = ({
  phoneNumber = {
    type: "work",
    number: "",
  },
  showErrors = false,
  disabled = false,
  fieldName,
  setFieldValue,
  className,
}: {
  phoneNumber?: PhoneNumber;
  showErrors?: boolean;
  disabled?: boolean;
  fieldName: string;
  setFieldValue: (
    field: string,
    value: PhoneNumber,
    shouldValidate?: boolean | undefined
  ) => void;
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-row gap-x-2 items-start", className)}>
      <div className="flex flex-col gap-y-1 flex-grow w-0">
        <SelectInput
          disabled={disabled}
          label="Number Type"
          value={phoneNumber.type}
          onValueChange={(type) => {
            setFieldValue(fieldName, { ...phoneNumber, type });
          }}
          options={["work", "mobile", "home", "other"].map((role) => (
            <SelectItem key={role} value={role}>
              {capitalize(role)}
            </SelectItem>
          ))}
          error={showErrors && !phoneNumber.type}
          errorMessage={
            showErrors && !phoneNumber.type ? "Must select a type" : undefined
          }
        />
      </div>
      <div className="flex-grow-[2] w-0">
        <Input
          disabled={disabled}
          value={phoneNumber.number}
          label="Phone Number"
          placeholder="814-123-4567"
          id="number"
          name="number"
          onChange={(event) =>
            setFieldValue(fieldName, {
              ...phoneNumber,
              number: event.target.value,
            })
          }
          error={showErrors && !phoneNumber.number}
          errorMessage={
            showErrors && !phoneNumber.number
              ? "Must enter a number"
              : undefined
          }
        />
      </div>
    </div>
  );
};
